/**
 * SectionHeader — counted section header for the immersive-setup screen:
 * uppercase label + optional count badge. Brand tokens only.
 */
interface SectionHeaderProps {
  label: string;
  /** Optional count, e.g. "3 sources" */
  count?: string;
  className?: string;
}

export const SectionHeader = ({ label, count, className }: SectionHeaderProps) => {
  return (
    <div className={`flex items-center justify-between mb-3 ${className ?? ""}`}>
      <h4 className="text-xs font-bold uppercase tracking-wide text-gray-500">{label}</h4>
      {count && (
        <span className="text-xs font-semibold text-genie-primary bg-genie-primary/10 px-2 py-0.5 rounded-full">
          {count}
        </span>
      )}
    </div>
  );
};

export default SectionHeader;
